import instObj from '@/backend/axios-instances'

const resource = "/cutsheets/part"
const instance = instObj.baseInstance

export default {
  get(partId, parameters) {
    return instance.get(`${resource}/${partId}`, { params: parameters });
  },
  put(partId, data) {
    return instance.put(`${resource}/${partId}`, data);
  },
  delete(partId) {
    return instance.delete(`${resource}/${partId}`);
  },
  addAttachment(partId, data) {
    return instance.post(`${resource}/${partId}/attachment`, data);
  }
}
